module.exports = __webpack_public_path__ + "img/2m.0db969e6.jpg";